export enum OrderItemStatusEnum {
  PREPARATION = 1,
  READY = 2,
  DELIVERED = 3,
  RETURN_BACK = 4,
}
